import { OrientableComponent } from "./OrientableComponent.types"


export class Entrance extends OrientableComponent {

  constructor() {
    super('entrance')

    // default position
    this.x = 200
    this.y = 200
    this.orientation = "RIGHT"
  }
}
